import { useEffect } from 'react'

import { Outlet, useLoaderData } from 'react-router-dom'

import SuspendedLayout from '@root/SuspendedLayout'

import request from '@fun/ajax/request'

import Footer from '@/Footer'

import FrontHeader from '@/Navigation/FrontHeader'
import ScrollToTop from '@/Navigation/ScrollToTop'

import setRolesStore from '@SF/setRolesStore'
import RolesStore    from '@Store/Roles'

import SetTitleAndMetas from '@/SEO/SetTitleAndMetas.jsx'

export default function FrontLayout ()
{
	const { page } = useLoaderData();

	const roles_status = RolesStore.useState(s => s.status);

	useEffect(() =>
	{
		if (roles_status !== 'pending') return;

		const controller = new AbortController();

		(async function fetchRoles ()
		{
			try
			{
				var { roles, user_id } = await request('/auth/get-roles')
				.config({ controller })
				.post();
			}
			catch (update)
			{
				return;
			}

			setRolesStore({ roles, user_id });
		})();

		return () => controller?.abort?.();
	},
	[roles_status]);

	return (
		<>
			<SetTitleAndMetas />

			<SuspendedLayout resolve={ page }>

				<div className="front-page">
					<FrontHeader />
					<Outlet />
					<ScrollToTop />
					<Footer />
				</div>

			</SuspendedLayout>
		</>
	);
}